 <template>
  <div class="app-container">
    <div class="top-title">
      <div class="header">
        <h3>More</h3>
        <img src="../assets/images/more2.png" alt="" />
      </div>
      <p class="title" v-if="nodetitle.length">{{ nodetitle }}</p>
      <p class="title" v-else>{{ title }}</p>
      <div class="search">
        <el-input
          v-model="filterText"
          placeholder="please enter the content"
        ></el-input>
        <i class="el-icon-search"></i>
      </div>
      <p class="close-open">
        <span>Content</span>
        <i class="el-icon-caret-bottom" v-if="!isOpen" @click="changeNodes"></i>
        <i class="el-icon-caret-top" v-else @click="changeNodes"></i>
      </p>
    </div>

    <el-tree
      :data="formattedTreeData"
      :props="defaultProps"
      @node-click="handleNodeClick"
      :filter-node-method="filterNode"
      node-key="id"
      highlight-current
      empty-text="No data available"
      ref="tree"
      :default-expand-all="false"
      class="custom-tree"
    >
      <template slot-scope="{ data }">
        <span v-if="data.isArticle" class="article-node">{{ data.label }}</span>
        <span v-else>{{ data.label }}</span>
      </template>
    </el-tree>

    <!-- 更多模块 -->
    <div
      class="more"
      v-show="showDiv"
      @mouseenter="toggleDiv"
      @mouseleave="toggleDiv"
    >
      <div class="search-model">
        <p>All Modules</p>
        <el-input
          v-model="filterModule"
          placeholder="please enter the content"
          @input="filterModel"
        ></el-input>
        <i class="el-icon-search"></i>
      </div>
      <ul>
        <li v-for="item in titleList" :key="item.id" @click="enterText(item)">
          {{ item.name }}
        </li>
      </ul>
    </div>
    <div class="mengban" @mouseenter="toggleDiv" @mouseleave="toggleDiv"></div>
  </div>
</template>

<script>
import { getCont, getModel, getUrl } from "../api/directory";
import { login } from "../api/login";

export default {
  props: {
    nodeId: {
      type: String,
      default: "",
    },
    nodetitle: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      filterText: "",
      treeData: [],
      formattedTreeData: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
      filterModule: "",
      showDiv: false,
      titleList: [],
      user: {
        username: "user",
        password: "123456",
      },
      isOpen: false,
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val.toLowerCase());
    },
    nodeId(val) {
      this.getTree();
    },
  },
  methods: {
    // 获取所有模块
    getList() {
      getModel({ level: 0 }).then((res) => {
        const tableData = res.data;
        const promises = tableData.map(async (item) => {
          const imageId = item.imageId;
          const res = await getUrl(imageId);
          item.imageUrl = res.data.mediaUrl;
          return item;
        });

        Promise.all(promises).then(() => {
          this.titleList = tableData;
        });
      });
    },

    // 目录筛选
    filterNode(value, data) {
      if (!value) return true;
      return data.label.toLowerCase().includes(value);
    },

    // 获取目录结构
    async getTree() {
      let dirid = "";
      this.nodeId ? (dirid = this.nodeId) : (dirid = this.$route.query.dirid);
      await getCont(dirid).then((res) => {
        this.treeData = this.mergeArrays(res.data.categoryInfo);
        this.formattedTreeData = this.formatTreeData(this.treeData);
      });
      this.nodeId ? "" : this.$emit("data-loaded");
    },

    // 合并 articles 和 childrenCategory 数组
    mergeArrays(categoryInfo) {
      const childrenCategory = categoryInfo.childrenCategory || [];
      const articles = categoryInfo.articles || [];
      const mergedArray = [...childrenCategory, ...articles];
      return mergedArray;
    },

    // 格式化数据
    formatTreeData(treeData) {
      return treeData.map((item) => ({
        label: item.categoryName || item.title || "",
        id: item.categoryId || item.articleId || "",
        children: this.formatSubItems(item),
        isArticle: item.title ? true : false,
      }));
    },

    // 格式化子项
    formatSubItems(item) {
      let formattedChildren = [];

      // 如果有子目录，递归格式化子目录
      if (item.childrenCategory && Array.isArray(item.childrenCategory)) {
        formattedChildren = item.childrenCategory.flatMap((subItem) => {
          const formattedSubItem = this.formatTreeData([subItem]);
          return formattedSubItem;
        });
      }

      // 如果有文章，将文章添加到子目录中
      if (item.articles && Array.isArray(item.articles)) {
        formattedChildren = formattedChildren.concat(
          item.articles.map((article) => ({
            label: article.title || "",
            isArticle: true, // 区分文章和目录
            articleId: article.articleId || "",
            id: article.articleId || "",
          }))
        );
      }
      return formattedChildren;
    },

    // 点击树节点
    handleNodeClick(data, node) {
      const expandParentNodes = (node) => {
        if (node && node.parent) {
          node.parent.expanded = true; // 展开父节点
          expandParentNodes(node.parent); // 递归展开上一级父节点
        }
      };

      // 展开当前节点
      node.expanded = true;

      // 展开所有父节点
      expandParentNodes(node);
      this.$store.commit("changeDirectory", data);
      this.$store.commit("selectMenu", { data, node });
    },

    // 根据id选中树节点
    setNode(id) {
      if (id) {
        this.$refs.tree.setCurrentKey(id);
        const node = this.$refs.tree.getNode(id);

        if (node) {
          const data = node.data;
          this.handleNodeClick(data, node);
        }
      } else {
        this.$refs.tree.setCurrentKey(null);
      }
    },

    findNodeById(node, id) {
      if (node.id === id) {
        return node;
      }
      if (node.children && node.children.length) {
        for (const child of node.children) {
          const foundNode = this.findNodeById(child, id);
          if (foundNode) {
            return foundNode;
          }
        }
      }
      return null;
    },

    // 搜索框过滤模块
    filterCont() {
      this.titleList = this.titleList.filter((item) => {
        return item.name
          .toLowerCase()
          .includes(this.filterModule.toLowerCase());
      });
    },

    // 搜索框输入事件
    filterModel() {
      // this.showDiv = true;
      this.filterModule.length ? this.filterCont() : this.getList();
    },

    // 更多模块--list点击事件
    enterText(item) {
      this.$emit("node-change", item);
    },

    // 显示更多模块
    toggleDiv() {
      this.showDiv = !this.showDiv;
      this.$emit("move", this.showDiv);
    },

    getUser() {
      login(this.user).then((res) => {
        const token = res.data.token;
        localStorage.setItem("token", token);

        this.getTree();
        this.getList();
      });
    },

    // 展开目录
    changeNodes() {
      this.isOpen = !this.isOpen;
      const node = this.$refs.tree.store.root;
      this.changeTreeNodeStatus(this.$refs.tree.store.root);
    },
    changeTreeNodeStatus(node) {
      node.expanded = this.isOpen;
      for (let i = 0; i < node.childNodes.length; i++) {
        // 改变节点的自身expanded状态
        node.childNodes[i].expanded = this.isOpen;
        // 看看他孩子的长度，有的话就调用自己往下找
        if (node.childNodes[i].childNodes.length > 0) {
          this.changeTreeNodeStatus(node.childNodes[i]);
        }
      }
    },
  },
  computed: {
    title() {
      return this.$route.query.label;
    },
    // isOpen() {
    //   return this.$route.query.itemId ? true : false;
    // },
  },
  mounted() {
    this.getUser();
  },
};
</script>

<style lang="less" scoped>
.app-container {
  width: 100%;
  box-sizing: border-box;
  position: relative;
  height: 90%;
  display: flex;
  flex-direction: column;

  .top-title {
    padding: 0 22px;
    flex-shrink: 0;

    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 0 15px 0;

      h3 {
        font-size: 22px;
        color: #333;
        font-weight: normal;
      }

      img {
        width: 20px;
        height: 20px;
      }

      img:hover {
        cursor: pointer;
      }
    }

    .title {
      padding: 20px 6px;
      font-size: 24px;
      font-weight: 500;
      color: #333;
      line-height: 1.167;
    }

    // 搜索框
    .search {
      position: relative;
      padding: 0 6px;

      i {
        position: absolute;
        top: 13px;
        left: 15px;
        color: #dcdfe6;
        cursor: pointer;

        &:hover {
          color: red;
        }
      }
      /deep/.el-input__inner {
        padding: 0 30px;
        height: 35px;
        margin: 0 0 28px 0;

        &:focus {
          border-color: red;
        }
      }
    }

    // 目录展开、收起
    .close-open {
      display: flex;
      justify-content: space-between;
      align-content: center;
      margin-bottom: 20px;
      padding: 0 6px;

      span {
        font-size: 16px;
        font-weight: 500;
        color: #999;
        line-height: 20px;
      }

      i {
        color: #999;
        font-size: 17px;
        cursor: pointer;
      }
    }
  }

  .custom-tree {
    width: 100%;
    flex-grow: 1;
    overflow-y: auto;
    /deep/.el-tree-node__content > .el-tree-node__expand-icon {
      color: black;
      font-size: 17px;
      margin-left: 15px;
    }

    /deep/.el-tree-node__expand-icon.is-leaf.el-tree-node__expand-icon {
      color: transparent;
      margin-left: 0;
    }

    /deep/.el-tree-node__content {
      padding: 5px 8px;
      min-height: 26px;
      height: auto;
      display: flex;
    }

    //点击节点
    /deep/.el-tree-node.is-current > .el-tree-node__content {
      background-color: #c45e6488;
    }

    // 鼠标悬浮节点
    /deep/.el-tree-node__content:hover {
      background-color: #c45e6488;
    }

    span {
      font-weight: 700;
      font-size: 16px;
      color: #333;
      display: inline-block;
      white-space: normal;
      word-break: keep-all;
      width: 100%;
    }

    .article-node {
      font-weight: normal;
    }

    &::-webkit-scrollbar {
      width: 6px; /* 滚动条的宽度 */
    }

    &::-webkit-scrollbar-track {
      background: transparent;
      border-radius: 5px;
    }

    &::-webkit-scrollbar-thumb {
      background: rgba(221, 221, 224, 0.4);
      border-radius: 5px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: rgba(199, 201, 204, 0.6);
    }
  }

  .more {
    position: absolute;
    top: 0;
    right: -281px;
    width: 280px;
    background-color: white;
    box-sizing: border-box;
    box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.1);
    transition: opacity 0.3s ease-in-out;
    overflow: auto;
    z-index: 9999;

    .search-model {
      position: relative;
      margin: 15px 15px 10px 15px;

      p {
        font-size: 18px;
        margin-bottom: 15px;
      }

      i {
        position: absolute;
        top: 48px;
        left: 10px;
        color: #dcdfe6;
        cursor: pointer;
      }

      i:hover {
        color: red;
      }

      /deep/.el-input__inner {
        padding: 0 30px;
        height: 35px;

        &:focus {
          border-color: red;
        }
      }
    }

    ul {
      list-style-type: none;
      font-size: 15px;
      padding: 0 0 10px 0;
      margin: 0;
      display: block;
      width: 100%;
      height: 340px;
      overflow: auto;

      &::-webkit-scrollbar {
        width: 6px; /* 滚动条的宽度 */
      }

      &::-webkit-scrollbar-track {
        background: white;
        border-radius: 5px;
      }

      &::-webkit-scrollbar-thumb {
        background: #dddee0;
        border-radius: 5px;
      }

      &::-webkit-scrollbar-thumb:hover {
        background: #c7c9cc;
      }

      li {
        padding: 12px 15px;
        cursor: pointer;

        &:hover {
          background-color: #c45e6488;
        }
      }
    }
  }

  .show {
    display: block;
  }

  .mengban {
    width: 80px;
    height: 50px;
    position: absolute;
    top: 0;
    right: -20px;
  }
}
</style>

